import { useEffect, useState } from 'react';
import apiClient from '@/services/apiClient';

let cache = null;

/** Pricing channels with New rates in Rates Master (TN first) — shared by every label-printing screen. */
export const usePricingChannels = () => {
  const [channels, setChannels] = useState(cache || ['TN']);
  useEffect(() => {
    if (cache) return;
    apiClient.get('/main-labels/pricing-channels')
      .then((r) => { cache = r.data.channels?.length ? r.data.channels : ['TN']; setChannels(cache); })
      .catch(() => {});
  }, []);
  return channels;
};

/** preview-batch said some SKUs have no rate in `pricingType` (their stickers would print blank) → message, else null. */
export const noRateMessage = (data, pricingType) => {
  const missing = data?.missing_rate || [];
  if (!missing.length) return null;
  const opts = data.rate_options || [];
  const skus = missing.slice(0, 5).join(', ') + (missing.length > 5 ? ` +${missing.length - 5} more` : '');
  return `No ${pricingType} rate in Rates Master for SKU ${skus} — ` + (opts.length
    ? `it has rates in ${opts.join(', ')}. Change the Pricing Type and print again.`
    : 'it has no rate in any pricing type. Add its rates first.');
};
